import { render } from "./TableEmptyStateNoResult.vue?vue&type=template&id=8b90edb0"
import script from "./TableEmptyStateNoResult.vue?vue&type=script&lang=js"
export * from "./TableEmptyStateNoResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__